<template>
    <div class="flex w-[65px] flex-col items-center justify-center gap-y-1 cursor-pointer group">
        <slot />
    </div>
</template>